import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesIT: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: 'Per avere diritto a questa offerta, è necessario (1) essere un professionista medico attualmente autorizzato ed (2) essere un membro di un ramo idoneo della professione medica. I rami idonei sono mostrati nel selettore di stato di questo modulo.<br><br>{companyName} utilizza SheerID, un partner di fiducia, per verificare che tu sia un professionista medico. SheerID raccoglie solo informazioni che aiutano a verificare la tua idoneità.<br>Possono essere richieste ulteriori informazioni o documentazione. ',
        },
        success: {
            verificationOnly: "SheerID si occupa solo della verifica. Ora che sei stato approvato, ti preghiamo di indirizzare tutte le domande sui termini della promozione e/o sull'uso del codice al servizio clienti<a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'CONTINUARE A TIMBERLAND',
        },
    },
};
